import React, { useContext } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import * as Sentry from '@sentry/react'

import { ContentLayout, RootLayout } from '@lyrahealth-inc/ui-core'
import { ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform'

import MicrositeAndElsewhereTopBanner from '../../../features/microsite/components/Banners/MicrositeAndElsewhereTopBanner'
import ComingSoonMicrositeHomeContainer from '../../../features/microsite/components/comingSoonContainer/ComingSoonMicrositeHomeContainer'
import LyraSelectComingSoonMicrositeHomeContainer from '../../../features/microsite/components/comingSoonContainer/LyraSelectComingSoonMicrositeHomeContainer'
import MicrositeIntlProvider from '../../../features/microsite/MicrositeIntlProvider'
import Header from '../header/Header'
import ToastContainer from '../toastContainer/ToastContainer'

const ComingSoon = () => {
  const { isLyraSelect } = useContext(ProductTypeContext)
  const ComingSoonHomepage = (
    <MicrositeIntlProvider>
      <MicrositeAndElsewhereTopBanner />
      <Header />
      <ToastContainer />
      <ContentLayout>
        {isLyraSelect ? <LyraSelectComingSoonMicrositeHomeContainer /> : <ComingSoonMicrositeHomeContainer />}
      </ContentLayout>
    </MicrositeIntlProvider>
  )

  const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)
  const router = sentryCreateBrowserRouter([
    {
      path: '*',
      index: true,
      element: ComingSoonHomepage,
    },
  ])

  return (
    <RootLayout>
      <RouterProvider router={router} />
    </RootLayout>
  )
}

export default ComingSoon
